import { render, staticRenderFns } from "./newOtherDialog.vue?vue&type=template&id=57927f68&scoped=true"
import script from "./newOtherDialog.vue?vue&type=script&lang=js"
export * from "./newOtherDialog.vue?vue&type=script&lang=js"
import style0 from "./newOtherDialog.vue?vue&type=style&index=0&id=57927f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57927f68",
  null
  
)

export default component.exports